﻿$.fn.mRemove = function mRemove() {
    mmRemove(this);
    this.remove();
}
window.mmRemove = function(lstEle) {
    for (var i = 0; i < lstEle.length; i++) {
        var lstSsEle = $(lstEle[i]).find(".dx-ctrl[dxctrlnom]")
        for (var j = 0; j < lstSsEle.length; j++) {
            $(lstSsEle[j]).deleteInstance();
        }
        $(lstEle[i]).deleteInstance();
    }
}
$.fn.getInstance = function getInstance() {
    var result = null;
    if (this.hasAttr("dxctrlnom")) {
        if (typeof lstDxCtrl[this.attr("dxctrlnom")] != 'undefined') {
            result = lstDxCtrl[this.attr("dxctrlnom")]
            //if (typeof result.getdxCtrlInstance != 'undefined') result = result.getdxCtrlInstance()
        }
    } else {
        if (typeof this.option != 'undefined') {
            result = this.option("instance")
        }
    }
    return result;
}
$.fn.getInstances = function getInstances() {
    var result = [];
    this.each(function (i,ele) {
        result.push(lstDxCtrl[$(ele).attr("dxctrlnom")])
    })
    return result;
}
$.fn.deleteInstance = function deleteInstance() {
    var instance = this.getInstance()
    if (instance) {
        //instance.element().add(instance.element().find("*")).each(function () {
        //    const $el2 = $(this);
        //    const dataKeys = Object.keys($el2.data());
        //    dataKeys.forEach(key => {
        //        if (key.startsWith("dx") && typeof $el2.data(key)?.dispose === "function") {
        //            $el2.data(key).dispose();
        //            console.log("🔙 DISPOSE " + $(this).attr("dxctrlnom") + " Reste: " + Object.keys(lstDxCtrl).length)
        //        }
        //    });
        //});
        if (typeof instance.dispose != 'undefined') instance.dispose()
        delete lstDxCtrl[$(this).attr("dxctrlnom")]
        console.log("❌ dxctrl " + $(this).attr("dxctrlnom")  + " Reste: " + Object.keys(lstDxCtrl).length)
    }
}
$.fn.hasAttr = function hasAttr(nom) {
    return typeof this.attr(nom) != "undefined" && this.attr(nom) != false
}
window.idxInstance = 0
window.lstDxCtrl = {};
$.fn.createInstance = function createInstance(instance) {
    idxInstance += 1
    lstDxCtrl["dxctrl" + idxInstance] = instance
    this.attr("dxctrlnom", "dxctrl" + idxInstance)
    instance.idxInstance = idxInstance
    this.instance = instance;
}

window.mMajDxCtrlPage = function(Class, itemData, suppression) {
    var lst = $("body").find("." + Class)
    for (var i = 0; i < lst.length; i++) {
        var dxCtrl = $(lst[i])
        if (typeof suppression != 'undefined' && suppression) { dxCtrl.getInstance().mRemoveItem(itemData); }
        else { dxCtrl.getInstance().mMajItem(itemData); }
    }
}

window.mGetDivDateIlYA = function(dat, reduce) {
    //var $DivDate = $("<div style='display:inline-block;padding-left:5px;'><div style='display:table;vertical-align: middle;'><div style='display:table-cell;vertical-align:middle;font-size:80%;'>" + dat.toDateIlya(reduce) + "</div></div></div>")
    var $DivDate = $("<div style='display:table-cell;vertical-align:middle;font-size:80%;'>" + dat.toDateIlya(reduce) + "</div>")
    //var $DivDate = $("<div>" + dat.toDateIlya(reduce) + "</div>")
    $DivDate.attr("title", dat.toFrenchDateTime().remplacerTout(" ", " à "))
    //$("<div/>").appendTo("body").dxCtrlTooltipHoverTarget({ target: $DivDate, position: "top", contentTemplate: function (contentElement) { $("<div style='font-size:110%;white-space:nowrap;'><b>Le </b>" + dat.toFrenchDateTime().remplacerTout(" ", "<b> à </b>") + "</div>").appendTo(contentElement); } });
    return $DivDate;
}